export default __webpack_public_path__ + "static/media/high-five.1bf6bc68.svg";